import axios from 'axios'

axios.defaults.headers.common['x-hasura-admin-secret'] = 'xlQsAzAk#Gah'


export async function getAllDecisions(baseURI){
  let response = {}

  response = await axios.post(baseURI, {
      query: `
      query getAllResults {
        results {
          user_code
          user {
            age
            events
            gender
            studies
          }
          session
          serie
          block
          initial_score
          selected_score
          target
          duration
        }
      }
      `
  })
  console.log("allDecisions",response) 
  let { data: { data:{ results } } } = response
  

  return results
}

export async function resultsValidaton(baseURI){
  let response = {}

  response = await axios.post(baseURI, {
      query: `
      query getUsersAndSessions {
        results:resultValidation {
          user_code
          session
          decisions
        }
      }
      `
  })
  console.log("resultsValidaton",response) 
  let { data: { data:{ results } } } = response
  

  return results
}

export async function getUsersAndSessions(baseURI){
  let response = {}

  response = await axios.post(baseURI, {
      query: `
      query getUsersAndSessions {
        results(distinct_on: session) {
          user_id
          user_code
          session
        }
      }
      `
  })
  
  let { data: { data:{ results } } } = response
  console.log("getUsersAndSessions",results)

  return results
}

export async function getAvailableCodes(baseURI,code){
    let response = {}
    let results = {}

    response = await axios.post(baseURI, {
        query: `
        query getAvailableCodes {
            user(distinct_on: code) {
                id
                code
            }
            }  
        `
    })
    
    let { data: { data:{ user: userCodes } } } = response
    console.log("getAvailableCodes",userCodes)
    return userCodes
}

export async function getSessionsByUserId(baseURI,userId){
    let response = {}
    let results = {}

    response = await axios.post(baseURI, {
        query: `
        query MyQuery($userId: Int!) {
            results(distinct_on: session, where: {user_id: {_eq: $userId}}) {
              session
              user_id
            }
          }  
        `,
		variables: {
			userId: userId
		}
    })
    console.log("***",response)
    let { data: { data:{ results: sessions } } } = response
    console.log("getSessionsByUserId",sessions)
    return sessions
}

export async function checkIfUserExist(baseURI,code){
	let response = {}
	let results = {}
	
	response = await axios.post(baseURI, {
		query: `
        query checkForUserCode($userCode: String = "") {
           users:user(where: {code: {_eq: $userCode}}) {
              age
              code
              events
              gender
              id
              studies
            }
          }  
        `,
		variables: {
			userCode: code
		}

	})
    console.log("checkIfUserExist",response)
	return response.data.data.users.length > 0 ? response.data.data.users[0] : {}
}

export async function createUser(baseURI,userData){
	let response = {}
	let results = {}
	
	response = await axios.post(baseURI, {
		query: `
          mutation CreateUser($object: user_insert_input = {}) {
            user:insert_user_one(object: $object) {
              id
              gender
              events
              code
              age
              studies
            }
          }`,
		variables: {
			object: userData 
		}

	})
	console.log("cretedUser",response)
	let user = response.data.data.user
    
    return user
}

export async function insertResults(baseURI,decisions){
	let response = {}
	let results = {}

	response = await axios.post(baseURI, {
		query: `
          mutation insertResults($objects: [results_insert_input!] = {}) {
            insert_results(objects: $objects) {
              affected_rows
            }
        }`,
		variables: {
			objects: decisions 
		}

	})
	console.log("insertedResults",response)

}

  export async function getDecisionsBySession(baseURI,sessionId){
	let response = {}

	response = await axios.post(baseURI, {
		query: `        
            query getResultsBySession($session: bigint = "") {
                decisionsCount:results_aggregate(where: {session: {_eq: $session}}) {
                    aggregate {
                        numDecisions:count
                    }
                }
                decisions:results(where: {session: {_eq: $session}}) {
                    session
                    serie
                    block
                    target                    
                    initial_score
                    selected_score
                    duration
                    user_code
                    user {
                        age
                        code
                        events
                        gender
                        studies
                    }
                }

                a:results_aggregate(where: {session: {_eq: $session}, block: {_eq: "3.1"}}) {
                  aggregate {
                    numDecisions: count
                    avgDuration:avg {
                      duration
                    }
                    sumDuration:sum {
                      duration
                    }
                    avgScore:avg {
                      selected_score
                    }
                  }
                }
                b:results_aggregate(where: {session: {_eq: $session}, block: {_eq: "3.2"}}) {
                  aggregate {
                    numDecisions: count
                    avgDuration:avg {
                      duration
                    }
                    sumDuration:sum {
                      duration
                    }
                    avgScore:avg {
                      selected_score
                    }
                  }
                }
                c:results_aggregate(where: {session: {_eq: $session}, block: {_eq: "3.3"}}) {
                  aggregate {
                    numDecisions: count
                    avgDuration:avg {
                      duration
                    }
                    sumDuration:sum {
                      duration
                    }
                    avgScore:avg {
                      selected_score
                    }
                  }
                }
                d:results_aggregate(where: {session: {_eq: $session}, block: {_eq: "4"}}) {
                  aggregate {
                    numDecisions: count
                    avgDuration:avg {
                      duration
                    }
                    sumDuration:sum {
                      duration
                    }
                    avgScore:avg {
                      selected_score
                    }
                  }
                }
            }
        `,
		variables: {
			session: sessionId 
		}

	})
	console.log("getDecisionsBySession",response)

    // let {
    //     data: { data: { decisionsCount: { aggregate: { count } } } }
    //   } = response
    
    //   let {
    //     data: { data: { decisions } }
    //   } = response
      
      let output = {}
      output.blocksSummary = []
      Object.keys(response.data.data).forEach(k => {
        let property = response.data.data[k]
        if (k == 'a'){
          output.blocksSummary.push({
            blockName:'3.1',
            numDecisions: property.aggregate.numDecisions,
            avgDuration: property.aggregate.avgDuration.duration,
            sumDuration: property.aggregate.sumDuration.duration,
            avgScore: property.aggregate.avgScore['selected_score'],
          })
        }else if(k == 'b'){
          output.blocksSummary.push({
            blockName:'3.2',
            numDecisions: property.aggregate.numDecisions,
            avgDuration: property.aggregate.avgDuration.duration,
            sumDuration: property.aggregate.sumDuration.duration,
            avgScore: property.aggregate.avgScore['selected_score'],
          })

        }else if(k == 'c'){
          output.blocksSummary.push({
            blockName:'3.3',
            numDecisions: property.aggregate.numDecisions,
            avgDuration: property.aggregate.avgDuration.duration,
            sumDuration: property.aggregate.sumDuration.duration,
            avgScore: property.aggregate.avgScore['selected_score'],
          })

        }else if( k == 'd'){
          output.blocksSummary.push({
            blockName:'4',
            numDecisions: property.aggregate.numDecisions,
            avgDuration: property.aggregate.avgDuration.duration,
            sumDuration: property.aggregate.sumDuration.duration,
            avgScore: property.aggregate.avgScore['selected_score'],
          })
        }
      })
      output.decisions = response.data.data.decisions
      output.numDecisions = response.data.data.decisions.length

      return output

}